const s = {
  name: "Elephant",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M34.3,9c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.3,1.2-1.3C33.7,7.8,34.3,8.3,34.3,9z"/>
		<path class="st0" d="M25,0c-3.1,0-5.9,1.6-7.5,4H9c-5,0-9,4-9,9v27h12V28h5v12h12V28h2c5,0,9-4,9-9V9c0-5-4-9-9-9H25z M9,6h7.5
			C16.2,6.9,16,7.9,16,9c0,5,4,9,9,9v-2c-3.9,0-7-3.1-7-7c0-3.9,3.1-7,7-7h6c3.9,0,7,3.1,7,7v10c0,3.9-3.1,7-7,7h-2v-2h2
			c1.4,0,2.6-0.6,3.5-1.5l0,0c0.9-0.9,1.5-2.2,1.5-3.5v-1h-9v20h-3V26H5v12H2V13C2,9.1,5.1,6,9,6z M10,38H7V28h3V38z M19,38V28h3v10
			H19z M29,22v-2h4.8c-0.2,0.4-0.4,0.8-0.7,1.1C32.6,21.7,31.8,22,31,22H29z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Elephant
};
